
import { Component, Vue } from 'vue-property-decorator'
import LsDialog from '@/components/ls-dialog.vue'

@Component({
  components: {
    LsDialog
  }
})
export default class IsCopyRight extends Vue {
    $refs!: { lsDialog: any }

    openDialog () {
      this.$refs.lsDialog.open()
    }
}
